import React from 'react';
import { Paper, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import Routes from './routes';
import WindowsManager from '../windowsManager';

function Body({ menuExpanded }) {
  const theme = useTheme();
  const t = theme.transitions.create(['margin']);
  return (
    <Paper
      sx={{
        ml: menuExpanded ? theme.menu.expanded.width : theme.menu.shrinked.width,
        transition: t,
        padding: 1,
        overflow: 'hidden',
        background: 'whitesmoke',
        mt: theme.menu.height,
        mb: theme.footer.height,
        height: `calc(100vh - ${theme.menu.height} - ${theme.footer.height})`,
        boxSizing: 'border-box',
        pl: 3,
      }}
      component="section"
    >
      <Routes />
      <WindowsManager />

    </Paper>
  );
}

Body.propTypes = {
  menuExpanded: PropTypes.bool.isRequired,
};

export default Body;
